import type { AiDisplayImage } from 'src/shared/graphql/generated';

import { CreatedFrom, FINAL_GENERATED_IMAGE_STATUSES } from '../static_values';
import type {
  AiImage,
  AiOrSampleDisplayImage,
  AiOrSampleGeneratedImage,
  Aspect,
} from '../types';
import { isSampleGenerated } from '../types';

export const isGeneratingImage = (image?: AiOrSampleGeneratedImage | null) => {
  if (!image || isSampleGenerated(image)) return false;

  const { generatedImagePath, status, clientStatus } = image;

  return (
    !generatedImagePath &&
    !FINAL_GENERATED_IMAGE_STATUSES.includes(status ?? '') &&
    !FINAL_GENERATED_IMAGE_STATUSES.includes(clientStatus ?? '')
  );
};

export const isOriginalImageDisplay = (image?: AiDisplayImage | null) =>
  image?.createdFrom === CreatedFrom.ORIGINAL && !image.aiGeneratedImage.edits;

/**
 * Determine whether an image is `interior` or `exterior` based on its
 * `spaceType`. Note that `exterior` is also a `spaceType`, but we have many
 * `spaceType`s for interior images.
 */
export const getImageAspect = ({
  spaceType,
}: AiOrSampleDisplayImage | AiImage): Aspect =>
  spaceType === 'exterior' ? 'exterior' : 'interior';
